import styled from '@emotion/styled';

import { fonts } from 'ms-pages/Lantern/styles';

export const Bold = styled.span(fonts.bodyBold);
